// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"3247db35","183":"4c148d98","271":"037c2d2a","896":"94aabf81"}[chunkId] + ".js";
};